// @flow
import * as React from 'react';
import Radium from 'radium';
import { compose, withState } from 'recompose';

import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

type RecomposeProps = {|
  +value: string,
  +onValueChange: (value: string) => void,
|};

type Props = RecomposeProps & {|
  +title: string,
  +inputType: 'textfield' | 'textarea',
  +initialValue: string,
  +onCancel: () => void,
  +onSubmit: (newValue: string) => void,
|};

class TextEditModal extends React.Component<Props> {
  render() {
    const {
      title,
      inputType,
      onCancel,
      value,
      onSubmit,
      onValueChange,
    } = this.props;
    return (
      <Modal style={_styles.root} isOpen>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <Input
            type={inputType}
            value={value}
            onChange={event => onValueChange(event.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button color="primary" onClick={() => onSubmit(value)}>
            Speichern
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const _styles = {
  root: {},
};

const TextEditModalContainer = compose(
  Radium,
  withState('value', 'onValueChange', ({ initialValue }) => initialValue)
)(TextEditModal);

export default TextEditModalContainer;



// WEBPACK FOOTER //
// ./src/components/TextEditModal/TextEditModal.js